webpackJsonp([12441591336514],{

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/career-header-big.7525bd84.jpg";

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/career-header-small.62c6be63.jpg";

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.List = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listStyle = /*#__PURE__*/(0, _reactEmotion.css)('list-style-type:none;margin:0;& h1{color:inherit;text-decoration:underline;}& a{color:black;cursor:pointer;opacity:1;transition:opacity .15s ease-in;transition:color .15s ease-in;&:hover{text-decoration:none;box-shadow:none;opacity:.5;transition:opacity .15s ease-in;}}');
	
	var List = exports.List = function List(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: listStyle },
	    children
	  );
	};

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _careerHeaderBig = __webpack_require__(110);
	
	var _careerHeaderBig2 = _interopRequireDefault(_careerHeaderBig);
	
	var _careerHeaderSmall = __webpack_require__(111);
	
	var _careerHeaderSmall2 = _interopRequireDefault(_careerHeaderSmall);
	
	var _Layout = __webpack_require__(7);
	
	var _Lists = __webpack_require__(38);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var vacancies = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Hero2.default,
	      {
	        imageBig: _careerHeaderBig2.default,
	        imageSmall: _careerHeaderSmall2.default
	      },
	      _react2.default.createElement(
	        _Layout.Box,
	        { color: 'white', p: [3, 3, 4], align: 'left' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Career'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        color: _colors2.default.black,
	        p: [3, 3, 4],
	        align: 'left'
	      },
	      _react2.default.createElement(
	        'p',
	        null,
	        'PCS is always hiring'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We teach people how to succed in high pressure envirnonments. If want to grow as a person and challenge yourself, think of a career at PCS.'
	      ),
	      _react2.default.createElement(
	        _Lists.List,
	        null,
	        vacancies.map(function (_ref2, index) {
	          var vacancy = _ref2.node;
	
	          return _react2.default.createElement(
	            'li',
	            { key: index },
	            _react2.default.createElement(
	              'h1',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: vacancy.fields.slug },
	                vacancy.frontmatter.title
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-career-index-js-457b2c98d7f82d994c42.js